import '../../styles/challenges.css';
import logo from '../../assets/images/Q3logotext.png';

function CQN() {
    return (
        <>
            <div className="header">
                <div class="header-content">
                    <div class="left">
                        <div class="header-box">
                            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
                        </div>
                        <p>September 12, 2025 - September 14, 2025</p>
                        <p>University of Maryland, College Park</p>
                        <p>Stamp Student Union</p>
                    </div>
                    <div className="right">
                        <img src={logo} className="logo" alt="Q^3 Logo" />
                    </div>
                </div>
            </div>
            <div className="challenge-content">
                <div className="info-section">
                    <h2>CQN Proposals</h2>
                    <p>The Center for Quantum Networks (CQN) seeks student-led proposals for projects
                        designed to teach quantum information science and engineering (QISE)
                        concepts to non-technical and semi-technical audiences.
                        Projects should include contextual explanations of quantum
                        applications for the concepts presented, and proposals should include details
                        on what end-users will learn and the learning theory the demonstration engages.
                        $10,000 per project; 1-2 semesters in duration; Proposal should be no more than 5 pages
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                    <div className="topics-section" style={{ flex: '1', minWidth: '300px' }}>
                        <h2>Requirements</h2>
                        <p>Create a computer demo usable on a desktop computer or tablet for outreach and engagement with learners interested in understanding some aspect of QISE. Make sure to include the following:</p>
                        <ul className="topics-list">
                            <li>Demo Title</li>
                            <li>Description: Please explain the concept that the team proposes to demonstrate. Explain what end-users will see and what they will understand when they engage with your demonstration.</li>
                            <li>Underpinning educational theory or framework: Explain how you intend to engage gamification, generative learning, or experiential learning in your demonstration</li>
                            <li>Intended usage and outcomes: State the intended audience for your demonstration, what they should understand, and how the impact of your demo will be assessed</li>
                            <li>Budget and Budget Justification: Provide a budget with accompanying explanation on how funds will be used to reach the project's goals</li>
                            <li>Project organization: Provide a list of team members, roles and responsibilities, and project timeline</li>
                            <li>Project demo: Provide a short video of your demo</li>
                        </ul>
                    </div>

                    <div className="topics-section" style={{ flex: '1', minWidth: '300px' }}>
                        <h2>Challenge Topics</h2>
                        <p>Projects may include but are not limited to the following suggestions:</p>
                        <ul className="topics-list">
                            <li>Visualization and explanation of how entanglement spreads in a network</li>
                            <li>Zeemax visualization of the classical interference in Young's N-slit to factor an odd number</li>
                            <li>Demonstrate how lattice defects work</li>
                            <li>Simulate the graph state manipulations when you perform certain Pauli unitaries, measurements, and fusion measurements</li>
                            <li>Demonstrate time-multi-plexed swaps for entanglement distribution</li>
                            <li>Simulate percolation-based creation of large random entangled states among an array of color center quantum memories</li>
                            <li>Create cluster states of photonic quantum computing starting with 3-photon cluster states</li>
                            <li>"Walk through" the Raussendorf lattice, "see" the qubits decohere over time, and "touch" the qubits with a wand to x, y, z measurements to see the fault tolerant quantum computation unfold</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CQN